/*
 * サブシステム名：マスタ管理
 * 機能名：燃料単価設定
 */

import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'

import header from '@/ddv2.library/header'
import kessanKikan from '@/ddv2.library/apis/business/kessanKikan'
import message from '@/ddv2.library/messages'

const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTextBox = () => import('@/components/DdTextBox')
const DdDefaultButton = () => import('@/components/DdDefaultButton')
const DdNarrowDownTextBox = () => import('@/components/DdNarrowDownTextBox')
const DdRowCountBox = () => import('@/components/DdRowCountBox')
const DdFooterButton = () => import('@/components/DdFooterButton')
const DdDataTable = () => import('@/components/DdDataTable')
const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdEditDialog = () => import('@/components/DdEditDialog')

export default {
  name: 'MstNenryoTankaEdit',
  mixins: [flowMixin],
  data: () => ({
    expansionPanel: [0, 1],
    conditions: {
      eigyoshoCd: '',
      tekiyoNendo: ''
    },
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    IsReadOnly: false,
    afterSearch: false,
    editMode: 0, // 0:新規, 1:更新
    updateList1: [],
    updateList2: [],
    updateList3: [],
    updateList4: [],
    updateList5: [],
    kiHeaders: [],
    monthHeaders: [],
    // 権限
    modeKengen: 0,
    modeOfEdit: 0,
    getNendo: ''
  }),
  components: {
    DdSubHeader,
    DdTextBox,
    DdDefaultButton,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdFooterButton,
    DdDataTable,
    DdCodeTextBox,
    DdEditDialog
  },
  computed: {
    ...mapGetters({
      eigyoshoList: 'DDMasters/mstEigyosho',
      kubunList: 'DDMasters/msysKubun',
      jininList: 'DDMasters/vwCMstEigyoshoJininList',
      kihonJoho: 'DDMasters/mstKihonJoho'
    }),
    filteredMsysKubun () {
      const listData = this.kubunList.filter(function (elem) {
        return elem.kbnShuruiCd === 'SFF053'
      }).map(function (elem) {
        elem.value = elem.code.trim()
        elem.text = elem.codeNm.trim()
        return elem
      })
      console.log('●●listData:', listData)
      return listData
    },
    filteredJininList () {
      const target = filter.dateFormatter(new Date())
      return this.jininList.map((elem) => {
        elem.jininNm = elem.jininNmSei + (elem.jininNmMei ? ' ' + elem.jininNmMei : '')
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.jininCd > elem2.jininCd) { return 1 }
        if (elem1.jininCd === elem2.jininCd) { return 0 }
        return -1
      })
    },
    filteredMstEigyosho () {
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    },
    filteredMstEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstEigyosho.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    },
    filteredRows () {
      return this.rows.map((elem) => {
        console.log('●●elem：', elem)
        if (elem.tekiyoMonth === 0) {
          elem.tekiyoMonthDisp = '上期'
        } else if (elem.tekiyoMonth === 13) {
          elem.tekiyoMonthDisp = '下期'
        } else {
          elem.tekiyoMonthDisp = elem.tekiyoMonth + '月'
        }
        return elem
      })
    },
    // 標準単価一覧
    filteredRowsK () {
      return this.rows.filter(function (elem) {
        return elem.tekiyoMonth === 0 || elem.tekiyoMonth === 13
      })
    },
    // 実績単価一覧
    filteredRowsM () {
      if (this.kihonJoho && this.kihonJoho[0]) {
        console.log('●●基本情報.決算月：', this.kihonJoho[0].kessanMonth)
        var self = this
        var startMonth = self.kihonJoho[0].kessanMonth === 12 ? 1 : self.kihonJoho[0].kessanMonth + 1
        console.log('●●filteredRowsM：', startMonth)
        return this.rows.filter(function (elem) {
          if (elem.tekiyoMonth < startMonth) {
            elem.tekiyoMonthSortkey = elem.tekiyoMonth + 12
          } else {
            elem.tekiyoMonthSortkey = elem.tekiyoMonth
          }
          console.log('●●filteredRowsM(elem)', elem)
          return elem.tekiyoMonth !== 0 && elem.tekiyoMonth !== 13
        }).sort((a, b) => {
          if (a.tekiyoMonthSortkey < b.tekiyoMonthSortkey) { return -1 }
          if (a.tekiyoMonthSortkey > b.tekiyoMonthSortkey) { return 1 }
          return 0
        })
      } else {
        return []
      }
    },
    isCreateButtonHide () {
      return this.CreateButtonHide
    },
    // 照会モード
    isShoukaiMode () {
      return this.modeOfEdit === 1
    },
    // キャンセルボタン・・・非表示：読取
    isCancelButtonDisp () {
      return this.modeKengen !== 0
    },
    // 削除ボタン・・・非表示：削除不可、読取
    isDeleteButtonDisp () {
      return this.modeKengen !== 0 && this.modeKengen !== 1
    },
    // 保存ボタン・・・・・・非表示：読取
    isSaveButtonDisp () {
      return this.modeKengen !== 0
    },
    // 削除ボタン・・・・・・検索前、該当データ無し、検索後に営業所コードや年度を変更した場合は使用不可
    isDeleteButtonDisabled () {
      return this.rows.length === 0 || this.afterSearch === false || this.editMode === 1
    },
    // 保存ボタン・・・・・・検索前、検索後に営業所コードや年度を変更した場合は使用不可
    isSaveButtonDisabled () {
      return this.rows.length === 0 || this.afterSearch === false
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  // beforeRouteUpdate (to, from, next) {
  //   this.$refs.initialize()
  //   next()
  // },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        afterSearch: this.afterSearch
      }
    },
    beforeRouteLeaveByMenu: function (next) {
      const opt = {
        nextCallback: next
      }
      this.preventTransition(opt)
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msteigyosho', 'msyskubun', 'vwcmsteigyoshojininlist', 'mstkihonjoho'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            self.headersClear()

            console.log('MstNenryoTankaEdit.defineHeaderPromise')
            // ヘッダ設定(区分マスタの設定で可変)
            var headerListK = [] // 標準単価一覧用(K)
            var headerListM = [] // 実績単価一覧用(M)
            var headerDataK = {}
            var headerDataM = {}
            console.log('●●filteredMsysKubun:', self.filteredMsysKubun)
            for (let i = 0; i < self.filteredMsysKubun.length; i++) {
              headerDataK = {}
              headerDataM = {}
              headerDataK.text = self.filteredMsysKubun[i].codeNm
              headerDataM.text = self.filteredMsysKubun[i].codeNm
              headerDataK.value = 'fuel' + self.filteredMsysKubun[i].code
              headerDataM.value = 'fuel' + self.filteredMsysKubun[i].code
              headerDataK.width = '100px'
              headerDataM.width = '100px'
              headerDataK.align = 'right'
              headerDataM.align = 'right'
              headerListK.push(headerDataK)
              headerListM.push(headerDataM)
              console.log('●●self.filteredMsysKubun[i].codeNm:', self.filteredMsysKubun[i].codeNm)
            }

            headerDataK = {}
            headerDataK.text = '期'
            headerDataK.value = 'tekiyoMonthDisp'
            headerDataK.width = '20px'
            headerDataK.align = 'center'
            headerListK.unshift(headerDataK)
            self.kiHeaders = headerListK

            headerDataM = {}
            headerDataM.text = '月'
            headerDataM.value = 'tekiyoMonthDisp'
            headerDataM.width = '20px'
            headerDataM.align = 'center'
            headerListM.unshift(headerDataM)
            self.monthHeaders = headerListM

            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise(resolve => {
            // 基本情報を元に年度を取得
            kessanKikan.calcNendoByDate(filter.dateFormatter(new Date()), self.kihonJoho[0].kessanMonth, self.kihonJoho[0].jishaShimeDay, self.kihonJoho[0].togetsuKijunHandanKbn).then(data => {
              self.getNendo = data.payload
              console.log('●●(initialize)self.getNend:', self.getNendo)
              self.conditions.tekiyoNendo = self.getNendo
            })
            self.conditions = {
              eigyoshoCd: '',
              tekiyoNendo: self.getNendo
            }
            self.dataClear()
            console.log('●●self.conditions.tekiyoNendo:', self.conditions.tekiyoNendo)
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('MstNenryoTankaEdit.savedInputRestorePromise', c)
          /* Example
          self.conditions = {
            hacchakuchiCd: c.hacchakuchiCd,
            hacchakuchiNm: c.hacchakuchiNm,
            torihikisakiCd: c.torihikisakiCd
          }
          */
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('MstNenryoTankaEdit.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('MstNenryoTankaEdit.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.conditions || {}
            self.search().then(() => {
              resolve()
            })
          })
        },
        restoreViewPromise: (c) => {
          console.log('MstNenryoTankaEdit.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.rows = c.cache.value.rows || []
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('MstNenryoTankaEdit.settingButtonStatePromise', kengen)
          return new Promise((resolve) => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              this.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              this.modeKengen = 1
            } else {
              // フルアクセス
              this.modeKengen = 2
            }
            // thisId == 0 then 新規モード
            if (this.id === 0) {
              this.modeOfEdit = 0 // 新規モード
            } else if (this.modeKengen === 0) {
              this.modeOfEdit = 1 // 照会モード
            } else {
              this.modeOfEdit = 2 // 更新モード
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        },
        settingViewScroll: () => {
          return true
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCMstNenryoTanka/Search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.dataClear()
          self.rows = data.payload
          console.log('●●search：', self.rows)

          var updDate = {
            id: '',
            kaishaCd: '',
            eigyoshoCd: '',
            nenryoTankaKbn: '',
            tekiyoNendo: '',
            tekiyoMonth: '',
            fuelKbn: '',
            tanka: '',
            insDate: '',
            insProgId: '',
            insUserId: '',
            updDate: '',
            updProgId: '',
            updUserId: ''
          }

          console.log('●●search：', self.rows)

          for (let i = 0; i < self.rows.length; i++) {
            // fuel01
            updDate.id = self.rows[i].id
            updDate.kaishaCd = self.rows[i].kaishaCd
            updDate.eigyoshoCd = self.conditions.eigyoshoCd
            updDate.nenryoTankaKbn = self.rows[i].nenryoTankaKbn
            updDate.tekiyoNendo = self.conditions.tekiyoNendo
            updDate.tekiyoMonth = self.rows[i].tekiyoMonth
            updDate.fuelKbn = '01'
            updDate.tanka = self.rows[i].fuel01
            updDate.insDate = self.rows[i].insDate
            updDate.insProgId = self.rows[i].insProgId
            updDate.insUserId = self.rows[i].insUserId
            updDate.updDate = self.rows[i].updDate
            updDate.updProgId = self.rows[i].updProgId
            updDate.updUserId = self.rows[i].updUserId
            console.log('●●updDate：', updDate)
            self.updateList1.push(JSON.parse(JSON.stringify(updDate)))

            // fuel02
            updDate.id = self.rows[i].id02
            updDate.kaishaCd = self.rows[i].kaishaCd
            updDate.eigyoshoCd = self.conditions.eigyoshoCd
            updDate.nenryoTankaKbn = self.rows[i].nenryoTankaKbn
            updDate.tekiyoNendo = self.conditions.tekiyoNendo
            updDate.tekiyoMonth = self.rows[i].tekiyoMonth
            updDate.fuelKbn = '02'
            updDate.tanka = self.rows[i].fuel02
            updDate.insDate = self.rows[i].insDate2
            updDate.insProgId = self.rows[i].insProgId2
            updDate.insUserId = self.rows[i].insUserId2
            updDate.updDate = self.rows[i].updDate2
            updDate.updProgId = self.rows[i].updProgId2
            updDate.updUserId = self.rows[i].updUserId2
            self.updateList2.push(JSON.parse(JSON.stringify(updDate)))

            // fuel03
            updDate.id = self.rows[i].id03
            updDate.kaishaCd = self.rows[i].kaishaCd
            updDate.eigyoshoCd = self.conditions.eigyoshoCd
            updDate.nenryoTankaKbn = self.rows[i].nenryoTankaKbn
            updDate.tekiyoNendo = self.conditions.tekiyoNendo
            updDate.tekiyoMonth = self.rows[i].tekiyoMonth
            updDate.fuelKbn = '03'
            updDate.tanka = self.rows[i].fuel03
            updDate.insDate = self.rows[i].insDate3
            updDate.insProgId = self.rows[i].insProgId3
            updDate.insUserId = self.rows[i].insUserId3
            updDate.updDate = self.rows[i].updDate3
            updDate.updProgId = self.rows[i].updProgId3
            updDate.updUserId = self.rows[i].updUserId3
            self.updateList3.push(JSON.parse(JSON.stringify(updDate)))

            // fuel04
            updDate.id = self.rows[i].id04
            updDate.kaishaCd = self.rows[i].kaishaCd
            updDate.eigyoshoCd = self.conditions.eigyoshoCd
            updDate.nenryoTankaKbn = self.rows[i].nenryoTankaKbn
            updDate.tekiyoNendo = self.conditions.tekiyoNendo
            updDate.tekiyoMonth = self.rows[i].tekiyoMonth
            updDate.fuelKbn = '04'
            updDate.tanka = self.rows[i].fuel04
            updDate.insDate = self.rows[i].insDate4
            updDate.insProgId = self.rows[i].insProgId4
            updDate.insUserId = self.rows[i].insUserId4
            updDate.updDate = self.rows[i].updDate4
            updDate.updProgId = self.rows[i].updProgId4
            updDate.updUserId = self.rows[i].updUserId4
            self.updateList4.push(JSON.parse(JSON.stringify(updDate)))

            // fuel05
            updDate.id = self.rows[i].id05
            updDate.kaishaCd = self.rows[i].kaishaCd
            updDate.eigyoshoCd = self.conditions.eigyoshoCd
            updDate.nenryoTankaKbn = self.rows[i].nenryoTankaKbn
            updDate.tekiyoNendo = self.conditions.tekiyoNendo
            updDate.tekiyoMonth = self.rows[i].tekiyoMonth
            updDate.fuelKbn = '05'
            updDate.tanka = self.rows[i].fuel05
            updDate.insDate = self.rows[i].insDate5
            updDate.insProgId = self.rows[i].insProgId5
            updDate.insUserId = self.rows[i].insUserId5
            updDate.updDate = self.rows[i].updDate5
            updDate.updProgId = self.rows[i].updProgId5
            updDate.updUserId = self.rows[i].updUserId5
            self.updateList5.push(JSON.parse(JSON.stringify(updDate)))
          }
          console.log('●●updateList1~5:', self.updateList1, self.updateList2, self.updateList3, self.updateList4, self.updateList5)

          self.rows = self.rows.map((nenryo) => {
          // self.recK = self.rows.map((nenryo) => {
            nenryo.fuel01 = filter.numericFormatter(Number(nenryo.fuel01))
            nenryo.fuel02 = filter.numericFormatter(Number(nenryo.fuel02))
            nenryo.fuel03 = filter.numericFormatter(Number(nenryo.fuel03))
            nenryo.fuel04 = filter.numericFormatter(Number(nenryo.fuel04))
            nenryo.fuel05 = filter.numericFormatter(Number(nenryo.fuel05))
            if (nenryo.tekiyoMonth === 0) {
              nenryo.tekiyoMonthDisp = '上期'
            } else if (nenryo.tekiyoMonth === 13) {
              nenryo.tekiyoMonthDisp = '下期'
            } else {
              nenryo.tekiyoMonthDisp = nenryo.tekiyoMonth + '月'
            }
            return nenryo
          })
          console.log('●●self.rows：', self.rows)

          if (data.summaryMessage === null) {
            self.editMode = 0 // 新規
          } else {
            self.editMode = 1 // 更新
          }

          self.afterSearch = true

          const cache = {
            rows: self.rows,
            conditions: self.conditions
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      this.search(opt)
    },
    clear: function () {
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            console.log('MstNenryoTankaEdit.clearInputsPromise')
            this.conditions = {
              eigyoshoCd: '',
              tekiyoNendo: this.getNendo
            }
            this.dataClear()
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    /**
     * キャンセルボタンクリック
     * @param {*} e
     */
    onCancelButtonClick: function (e) {
      console.log('MstNenryoTanka.onCancelButtonClick', e)
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            // self.rows = []
            self.conditions = {
              eigyoshoCd: '',
              tekiyoNendo: self.getNendo
            }
            self.dataClear()
            resolve()
          })
        }
      }

      this.cancelInputs(opt)
    },
    /**
     * 削除ボタンクリック
     * @param {*} e
     */
    onDeleteButtonClick: function (e) {
      const self = this
      const opt = {
        deleteRequestPromise: function () {
          var updList = []
          var updateList = {}
          updList = self.updateList1.concat(self.updateList2, self.updateList3, self.updateList4, self.updateList5)
          updateList.mstNenryoTankaList = updList
          console.log('●MstNenryoTankaEdit.deleteRequestPromise(削除用配列)：', updateList)

          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/MstNenryoTanka/DeleteMulti?', updateList).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0
            // param: { id: self.id }
          }
        },
        settingReloadWindow: function () {
          return true
        }
        // getSavedInputMethod: function () {
        //   return {}
        // }
      }
      this.delete(opt)
    },
    /**
     * 保存ボタンクリック
     * @param {*} e
     */
    onSaveButtonClick: function (e) {
      console.log('●MstNenryoTankaEdit.onSaveButtonClick', e)
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          console.log('●MstNenryoTankaEdit.registerResponsePromise', data)
          return new Promise(resolve => {
            self.id = data.payload.id
            this.onSearchButtonClick()
            resolve()
          })
        },
        getIdMethod: () => {
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            this.id = id
            // this.transition(0, { }, this.initialize)
            // this.transition(0, { id: id }, this.initialize)
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0
            // param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          return self.id !== 0
        },
        isNoRefreshModeMethod: function () {
          return true
        }
      }

      this.register(opt)
    },
    registerPromise: function () {
      console.log('●MstNenryoTankaEdit.registerPromise')
      var updList = []
      var updateList = {}
      updList = this.updateList1.concat(this.updateList2, this.updateList3, this.updateList4, this.updateList5)
      updateList.eigyoshoCd = this.conditions.eigyoshoCd
      updateList.tekiyoNendo = this.conditions.tekiyoNendo
      updateList.mstNenryoTankaList = updList
      console.log('●MstNenryoTankaEdit.registerPromise(更新用配列)：', updateList)
      const f = this.HttpClient.post('/api/v1/MstNenryoTanka/UpdateMulti?', updateList)
      return f
    },
    onRowClick: function (e) {
      console.log(e)
      this.Effects.loadStart()

      this.transition(0, { id: e.id })
    },
    searchValidate: function () {
      if (Number(this.conditions.tekiyoNendo) >= 2000 && Number(this.conditions.tekiyoNendo) <= 2999) {
        return true
      }
      this.$refs.tekiyoNendo[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0120', ['適用年度', '2000', '2999']))
      return false
    },
    registerValidate: function () {
      return true
    },
    deleteValidate: function () {
      return true
    },
    // 単価(fuel01)
    tankaSave1: function (e, row) {
      console.log('●●tankaSave1:', e, row)
      console.log('●●tankaSave1(updateList1):', this.updateList1)
      if (e === true && isFinite(row.value)) {
        const targetItem = this.updateList1.findIndex((rec) => rec.tekiyoMonth === row.item.tekiyoMonth)
        this.updateList1[targetItem].tanka = row.item.fuel01
        console.log('●●tankaSave1(updateList1):', this.updateList1)
      }
    },
    // 単価(fuel02)
    tankaSave2: function (e, row) {
      console.log('●●tankaSave2:', e, row)
      if (e === true && isFinite(row.value)) {
        const targetItem = this.updateList2.findIndex((rec) => rec.tekiyoMonth === row.item.tekiyoMonth)
        this.updateList2[targetItem].tanka = row.item.fuel02
      }
    },
    // 単価(fuel03)
    tankaSave3: function (e, row) {
      console.log('●●tankaSave3:', e, row)
      if (e === true && isFinite(row.value)) {
        const targetItem = this.updateList3.findIndex((rec) => rec.tekiyoMonth === row.item.tekiyoMonth)
        this.updateList3[targetItem].tanka = row.item.fuel03
      }
    },
    // 単価(fuel04)
    tankaSave4: function (e, row) {
      console.log('●●tankaSave4:', e, row)
      if (e === true && isFinite(row.value)) {
        const targetItem = this.updateList4.findIndex((rec) => rec.tekiyoMonth === row.item.tekiyoMonth)
        this.updateList4[targetItem].tanka = row.item.fuel04
      }
    },
    // 単価(fuel05)
    tankaSave5: function (e, row) {
      console.log('●●tankaSave5:', e, row)
      if (e === true && isFinite(row.value)) {
        const targetItem = this.updateList5.findIndex((rec) => rec.tekiyoMonth === row.item.tekiyoMonth)
        this.updateList5[targetItem].tanka = row.item.fuel05
      }
    },
    // datatable関連クリア
    dataClear: function () {
      this.rows = []
      this.updateList1 = []
      this.updateList2 = []
      this.updateList3 = []
      this.updateList4 = []
      this.updateList5 = []
      this.afterSearch = false
      this.editMode = 0
    },
    headersClear: function () {
      this.kiHeaders = []
      this.monthHeaders = []
    },
    onChange: function () {
      this.afterSearch = false
    }

  }
}
